@if (showSkeleton()) {
  <div class="loading-skeleton">
    <div class="skeleton-item skeleton-chart"></div>
    <table class="skeleton-table">
      <thead>
        <tr class="skeleton-date-row">
          <th class="skeleton-spacer"></th>
          @for (_ of skeletonColumns; track $index) {
            <th>
              <div class="skeleton-item skeleton-date-cell"></div>
            </th>
          }
        </tr>
      </thead>
      <tbody>
        @for (_ of skeletonRows; track $index) {
          <tr class="skeleton-risk-row">
            <td class="skeleton-spacer">
              <div class="skeleton-item skeleton-icon"></div>
            </td>
            @for (_ of skeletonColumns; track $index) {
              <td>
                <div class="skeleton-item skeleton-risk-cell"></div>
              </td>
            }
          </tr>
        }
      </tbody>
    </table>
  </div>
} @else {
  @if (store.isPlantDateInFuture()) {
    {{ plantDateInFutureMessageKey() | translate }}
  }

  @if (!store.isPlantDateInFuture() && !store.hasAdvices() && !showDataWithoutAdvices()) {
    {{ noAdviceAvailableMessageKey() | translate }}
  }

  @if (store.hasAdvicesForSelectedRange() || showDataWithoutAdvices()) {
    <div class="chart-container">
      @if (store.isChartVisible()) {
        <div class="chart-visual" [class.is-muted]="showDataWithoutAdvices()" [class.has-no-data]="!hasGraphData()">
          <agr-chart
            #chart
            (created)="onChartCreated($event.chartRef)"
            [attr.aria-disabled]="!hasGraphData()"
            [attr.inert]="!hasGraphData() ? '' : null"
            [dataSource]="store.chartDataSeries()"
            [options]="store.chartSeriesOptions()"
            style="margin-top: 50px"
          >
          </agr-chart>
          @if (showDataWithoutAdvices()) {
            <div class="no-advice-overlay" role="status">
              {{ dataWithoutAdvicesMessageKey() | translate }}
            </div>
          }
        </div>
        @if (betweenChartAndTableTemplate(); as betweenChartAndTableTemplate) {
          <ng-container *ngTemplateOutlet="betweenChartAndTableTemplate; context: { chart: this }"></ng-container>
        }
        @if (store.chartDays(); as days) {
          <div [style.margin-right.px]="tableMarginRight()">
            <table class="chart-table" [class.is-muted]="showDataWithoutAdvices()">
              <thead>
                <tr class="details-row date-row">
                  <th [style.width.px]="tableMarginLeft()" class="no-borders" style="padding: 0"></th>
                  @for (day of days; track day.date) {
                    <th [class.chart-date-today-highlight]="isToday(day.date)" scope="col">
                      <button
                        type="button"
                        class="clickable-date-cell flex--nowrap flex--align-center flex--justify-center"
                        (click)="onAction($event, day.date)"
                      >
                        {{ day.date | date: 'EEE dd/MM' : undefined : store.locale() }}
                        @if (dateHeaderAccessoryTemplate(); as dateHeaderAccessoryTemplate) {
                          <ng-container
                            *ngTemplateOutlet="dateHeaderAccessoryTemplate; context: { $implicit: day }"
                          ></ng-container>
                        }
                      </button>
                    </th>
                  }
                </tr>
              </thead>
              <tbody>
                <tr class="details-row">
                  <td class="no-borders"></td>
                  @for (day of days; track day.date) {
                    <td
                      [style]="day.adviceStylingOverride"
                      (mouseenter)="showAdviceTooltip($event, day.adviceTooltipKey)"
                      (mouseleave)="hideTooltip()"
                    >
                      <button type="button" class="advice-container" (click)="onAction($event, day.date)">
                        @if (day.sprayTime) {
                          <div class="icon-container">
                            <img
                              alt
                              class="blight-icon spray"
                              height="24"
                              ngSrc="assets/icons/sprays_or_irrigation.svg"
                              width="24"
                            />
                          </div>
                        }
                        <span>{{ day.adviceTranslationKey | translate }}</span>
                      </button>
                    </td>
                  }
                </tr>

                @if (riskTableRowsTemplate(); as riskTableRowsTemplate) {
                  <ng-container
                    *ngTemplateOutlet="riskTableRowsTemplate; context: { $implicit: days, chart: this }"
                  ></ng-container>
                }
              </tbody>
            </table>
          </div>
        }
      }
      <div
        #customTooltip
        [hidden]="!showCustomTooltip"
        [style.left.px]="mouseX"
        [style.top.px]="mouseY"
        class="custom-tooltip"
      >
        {{ tooltipText }}
      </div>
    </div>
  }
}
